'use es6';

import { createSelector } from 'reselect';
import SeamlessImmutable from 'seamless-immutable';
import { getActiveAssetId } from 'DesignData/selectors/app';

const getByAssetDictionary = state => state.previewOptions.byAsset;

const getOptionsForAssetId = createSelector([getByAssetDictionary, getActiveAssetId], (byAsset, assetId) => {
  return byAsset[assetId] || byAsset.default;
});
export const getIsPreviewOpen = createSelector([getOptionsForAssetId], opts => opts.isPreviewOpen);
export const getPreviewConfiguration = createSelector([getOptionsForAssetId], opts => opts.previewConfiguration);

const getBlogTemplatePreviewConfiguration = (state, props) => {
  const blogsById = state.blogs.byId;
  const {
    assetPath
  } = props; // eslint-disable-next-line guard-for-in

  for (const blogIdKey in blogsById) {
    const blog = blogsById[blogIdKey];

    if (blog.itemTemplatePath === assetPath || blog.listingTemplatePath === assetPath) {
      return {
        previewBlogId: blog.id,
        previewBlogPostView: blog.itemTemplatePath === assetPath
      };
    }
  }

  return null;
};

export const makeGetBlogTemplatePreviewConfiguration = () => {
  let state = SeamlessImmutable({});
  return createSelector([getPreviewConfiguration, getBlogTemplatePreviewConfiguration], (cachedConfiguration, blogConfiguration) => {
    const props = Object.assign({}, cachedConfiguration);

    if (blogConfiguration) {
      if (cachedConfiguration.previewBlogId === null) {
        props.previewBlogId = blogConfiguration.previewBlogId;
      }

      if (cachedConfiguration.previewBlogPostView === null) {
        props.previewBlogPostView = blogConfiguration.previewBlogPostView;
      }
    }

    state = state.merge(props, {
      deep: true
    });
    return state;
  });
};
export const getBuildsError = state => state.previewOptions.projectOptions.error;
export const getBuilds = state => state.previewOptions.projectOptions.builds;
export const getTemplateBuilds = state => state.previewOptions.projectOptions.templateBuilds;